<template>
  <div class="container">
    <van-image style="display: block; margin: 0 auto" :src="require('@/assets/culturalRelic/biao@2x.png')"></van-image>
    <van-form label-align="right" label-width="90" class="form" @submit="onSubmit" colon scroll-to-error>
<!--      <section class="date">-->
<!--        <van-field-->
<!--          v-model="time"-->
<!--          name="date"-->
<!--          label="鉴定咨询日期"-->
<!--          disabled-->
<!--          placeholder="请选择鉴定咨询日期"-->
<!--          :rules="[{ required: true, message: '请选择鉴定咨询日期' }]"-->
<!--        />-->
<!--      </section>-->
      <van-popup v-model="showPopup" position="bottom" round :overlay-style="{ backgroundColor: 'rgba(0, 0, 0, .5)' }">
        <van-datetime-picker
          :value="form.date"
          type="date"
          title="选择年月日"
          @confirm="onSelectDate"
          @cancel="onCancel"
        />
      </van-popup>
      <!-- eslint-disable no-irregular-whitespace -->
      <section class="register-information">
        <van-image class="title-icon" :src="require('@/assets/culturalRelic/xinxi.png')"></van-image>
        <van-field
          v-model="form.username"
          name="username"
          label="姓　　名"
          required
          placeholder="请输入"
          :rules="[{ required: true, message: '请填写姓名' }]"
        />
        <van-field
          v-model="form.idNumber"
          name="idNumber"
          label="身份证号"
          required
          placeholder="请输入"
          :rules="[{ required: true, message: '请正确填写身份证号', pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/ }]"
        />
        <van-field
          v-model="form.phoneNumber"
          name="phoneNumber"
          label="联系方式"
          required
          placeholder="请输入"
          :rules="[{ required: true, message: '请正确填写联系方式', pattern: /^(13[0-9]|14[5|7]|15[0|1|2|3|4|5|6|7|8|9]|18[0|1|2|3|4|5|6|7|8|9])\d{8}$/ }]"
        />
        <template v-for="(item, index) of form.group">
          <section :key="index">
            <van-field
              v-model="item.itemName"
              name="itemName"
              label="物品名称"
              required
              placeholder="请输入"
              :rules="[{ required: true, message: '请填写您要鉴定的物品的名称' }]"
            />
            <van-field
              v-model="item.sizeSpecification"
              name="sizeSpecification"
              rows="3"
              autosize
              label="尺寸规格"
              required
              type="textarea"
              maxlength="20"
              placeholder="请输入您要鉴定的物品的尺寸。如：600cmx200cm"
              :rules="[{ required: true, message: '请填写您要鉴定的物品的尺寸' }]"
            />
            <van-field
              v-model="item.sourceDescription"
              name="sourceDescription"
              rows="3"
              autosize
              label="来源说明"
              required
              type="textarea"
              maxlength="200"
              show-word-limit
              placeholder="请输入您的物品来源说明"
              :rules="[{ required: true, message: '请填写您的物品来源说明' }]"
            />
            <section class="upload-personal">
              <!-- <van-image class="title-icon" :src="require('@/assets/culturalRelic/tupian@2x.png')"></van-image> -->
              <label>图片上传：</label>
              <van-uploader
                class="upload"
                v-model="item.itemPicture"
                preview-size="27vw"
                max-count="3"
                multiple
              />
            </section>
          </section>
        </template>
      </section>
      <section v-if="form.group.length <= 1" class="stepper" @click="addGroup">
        <i><van-icon name="plus" /></i>继续添加物品（可选）
      </section>
      <section class="notice">
        <div class="content">
          <h4>预约须知</h4>
          <div v-html="content"></div>
        </div>
      </section>
      <section class="btns">
        <van-button round block color="#BF6A55" text="确认" native-type="submit"/>
        <router-link :to="{ path: '/culturalRelic/queryResule', query: { id: $route.params.id } }">
          <van-button native-type="button" round block color="#BF6A55" text="我的报名"/>
        </router-link>
      </section>
    </van-form>
    <van-popup
      class="popup"
      round
      :overlay-style="{ backgroundColor: 'rgba(0, 0, 0, .5)' }"
      v-model="showPopups"
      :close-on-click-overlay="false"
      @opened="onPopupOpened"
    >
      <template v-if="times">
        <span class="count-down">倒计时{{ times }}s</span>
      </template>
      <template v-else>
        <span class="count-down" @click="handlePopupStatus">关闭</span>
      </template>
      <van-image width="100%" :src="require('@/assets/wwjd-zyzzc@2x.png')"/>
      <div class="content">
        <div v-html="listData.activityNotice"></div>
        <div v-html="listData.commitment"></div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import moment from 'moment'
import { applyAdd, getBasicOne, Uploader } from '@/api/culturalRelic'

export default {
  name: 'CulturalRelicSignUp',
  data: () => ({
    form: {
      date: new Date(),
      username: null,
      idNumber: null,
      phoneNumber: null,
      group: [{
        itemName: '',
        sizeSpecification: null,
        sourceDescription: '',
        itemPicture: []
      }]
    },
    showPopup: false,
    showPopups: false,
    content: sessionStorage.getItem('appointment'),
    time: sessionStorage.getItem('time'),
    imgList: [],
    times: 3,
    listData: {}
  }),
  computed: {
    date () {
      return moment(this.form.date).format('YYYY-MM-DD') || ''
    }
  },
  mounted () {
    this.ditileData()
    this.showPopups = true
  },
  methods: {
    async ditileData () {
      const { result } = await getBasicOne()
      console.log(result)
      this.listData = result
    },
    onPopupOpened () {
      let timer = null
      timer = setInterval(() => {
        if (this.times > 0) {
          this.times--
        } else {
          clearInterval(timer)
        }
      }, 1000)
    },
    handlePopupStatus () {
      this.showPopups = !this.showPopups
    },
    async onSubmit () {
      console.log(this.form)
      for (const i in this.form.group) {
        for (const j in this.form.group[i].itemPicture) {
          // this.imgList.push([])
          const resData = await Uploader(this.form.group[i].itemPicture[j].file)
          console.log(resData.result)
          this.form.group[i].itemPicture[j] = resData.result
          // this.imgList[j].push(resData.result)
          // this.form.group[i].itemPicture = this.imgList
        }
      }
      /* for (const i in this.form.img) {
        const resData = await Uploader(this.form.img[i].file)
        console.log(resData)
        this.imgList.push(resData.result)
      } */
      const { request } = await applyAdd({
        ownedActivity: this.$route.params.id,
        name: this.form.username,
        identityNumber: this.form.idNumber,
        contact: this.form.phoneNumber,
        list: this.form.group
      })
      console.log(request)
      this.$toast.success('报名成功')
      this.$router.replace(`/culturalRelic/SignResults/${this.$route.params.id}`)
    },
    handleDatePopup () {
      this.showPopup = true
    },
    onSelectDate (value) {
      console.log(value)
      this.form.date = value
      this.showPopup = false
    },
    onCancel () {
      this.showPopup = false
    },
    addGroup () {
      console.log('添加一组物品')
      this.form.group.push({
        itemName: '',
        sizeSpecification: null,
        sourceDescription: '',
        itemPicture: []
      })
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .van-cell__title {
  padding-right: 15px;
}
::v-deep .van-cell--required::before {
  top: 10px;
  left: 15px;
}
.popup {
  width: 70vw;
  height: 60vh;
  padding: 10px 16px;
  background-color: #F7EEE8;

  .count-down {
    border: 1px solid #312925;
    border-radius: 12px;
    padding: 4px 12px;
    box-sizing: border-box;
    font-size: 14px;
    float: right;
    margin-bottom: 10px;
  }

  .content {
    height: 80%;
    overflow-x: hidden;
    overflow-y: scroll;
    padding-right: 10px;
    text-align: justify;
  }

  ::v-deep p {
    color: #312925;
    font-size: 12px;
    line-height: 2;
  }
}

.container {
  padding: 20px 10px;
  box-sizing: border-box;
  min-height: 100vh;
  background-color: #F7EEE8;
  font-family: 'PingFangMedium';
  .form {
    ::v-deep .nameyz {
      &::before {
        left: 40px;
      }
    }
    .dates {
      margin: 10px 0;
      padding: 10px 5px;
      font-size: 14px;
      color: #312925;
      text-align: center;
      background: #F7EEE8;
      border: 1px solid #333333;
      border-radius: 3px;
      box-shadow: inset 0 0 3px #ccc;
    }

    > section {
      margin-top: 25px;
    }

    > section.date {
      border: 1px solid #F7EEE8;
      box-shadow: inset 0 0 3px #F7EEE8;
      background-color: #F1E6DD;
      border-radius: 3px;
      white-space: nowrap;
      ::v-deep .van-cell__title {
        vertical-align: middle;
      }
      ::v-deep .van-cell {
        background-color: transparent;
        font-size: 12px;

        .van-field__label {
          color: #312925;
        }

        .van-field__control:disabled {
          -webkit-text-fill-color: #312925;
        }
      }
    }

    .register-information {
      .title-icon {
        width: 100px;
        height: 22px;
      }

      ::v-deep .van-cell {
        background-color: transparent;

        .van-field__label {
          width: 5em;
          height: auto;
          padding-top: 5px;
          margin-right: 0;
        }

        &.van-field {
          padding: 5px 15px;
        }

        .van-field__word-limit {
          margin-top: -18px;
          margin-right: 8px;
          color: #BAA69C;
        }

        .van-field__body {
          input, textarea {
            border: 1px solid #F7EEE8;
            box-shadow: inset 0 0 3px #F7EEE8;
            border-radius: 3px;
            padding: 0 6px;
            background-color: #F1E6DD;
            border: 0;
          }
          ::-webkit-input-placeholder { color:#BAA69C; }
          input {
            height: 35px;
          }

          textarea {
            height: 100px;
          }
        }
      }
    }

    .upload-personal {
      position: relative;
      padding-left: 20px;
      label {
        display: block;
        margin-bottom: 10px;
        margin-left: 10px;
        font-size: 14px;
        color: #646566;
        &::before {
          content: '*';
          position: absolute;
          left: 14px;
          color: #ee0a24;
          font-size: 14px;
        }
      }
      .title-icon {
        margin-bottom: 10px;
        display: block;
        width: 108px;
      }
    }

    .stepper {
      text-align: center;
      color: #333;
      font-size: 16px;
      background-color: #F1E6DD;
      line-height: 2.5;
      border-radius: 3px;
      vertical-align: middle;
      > i {
        width: 20px;
        line-height: 20px;
        display: inline-block;
        margin-right: 10px;
        text-align: center;
        background-color: #fff;
        border-radius: 3px;
      }
    }

    .notice {
      ::v-deep h4 {
        font-size: 16px;
        color: #312925;
        font-weight: 500;
        line-height: 1.2;
        margin: 10px 0;
        text-align: center;
        font-family: 'PingFangBold';
      }

      .content {
        width: 100%;
        min-height: 94px;
        border-radius: 3px;
        border-radius: 3px;
        padding: 5px 6px;
        background-color: #F1E6DD;
        box-sizing: border-box;
      }
    }

    .btns {
      .van-button {
        font-size: 16px;

        &:first-child {
          margin-bottom: 20px;
        }
      }
    }
  }
}
</style>
